const SHOW_ERROR = 'comex/SystemError/SHOW_ERROR'
const HIDE_ERROR = 'comex/SystemError/HIDE_ERROR'
const CLEAR_ERROR = 'comex/SystemError/CLEAR_ERROR'

export const showSystemError = message => ({
  type: SHOW_ERROR,
  payload: { message, visible: true },
})

export const hideSystemError = () => ({
  type: HIDE_ERROR,
  payload: { visible: false },
})

export const clearSystemError = () => ({
  type: CLEAR_ERROR,
  payload: { message: '' },
})

const defaultState = {
  message: '',
  visible: false,
}

const reducer = (state = defaultState, { type, payload } = {}) => {
  switch (type) {
    case SHOW_ERROR:
    case HIDE_ERROR:
    case CLEAR_ERROR:
      return { ...state, ...payload }

    default:
      return state
  }
}

export default reducer
